const STYLE = `
  #toast { position: fixed; z-index: 210; top: 24px; left: 50%; transform: translateX(-50%); max-width: calc(100% - 32px); text-align: center; background: #fffdf5; color: #173420; border: 3px solid #b9d8aa; box-shadow: 0 6px 18px #1d352977; padding: 12px 22px; border-radius: 999px; font: 700 17px system-ui, sans-serif; opacity: 0; transition: opacity .3s; pointer-events: none; }
  #toast.show { opacity: 1; }
`;

export function createToast(): { show(message: string): void } {
  const style = document.createElement("style");
  style.textContent = STYLE;
  document.head.appendChild(style);

  const el = document.createElement("div");
  el.id = "toast";
  document.body.appendChild(el);

  let timer: ReturnType<typeof setTimeout> | undefined;

  return {
    show(message) {
      el.textContent = message;
      el.classList.add("show");
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => el.classList.remove("show"), 2500);
    },
  };
}
